export default function ({ route, redirect }) {
  if (route.name == 'panel') {
    return redirect('/panel/groups');
  }
}
